import React, { useEffect } from 'react';
import styles from './procedimentos_marjorie_lashdesign.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5564993010303';

const SOBRANCELHA = [
    { nome: 'Design de sobrancelha personalizado', valor: 'R$ 30,00' },
    { nome: 'Design masculino', valor: 'R$ 40,00' },
    { nome: 'Design de sobrancelha com aplicação de henna', valor: 'R$ 45,00' },
    { nome: 'Brow lamination', valor: 'R$ 100,00' },
    { nome: 'Depilação do buço', valor: 'R$ 20,00' },
];

const TECNICAS = [
    {
        id: 'americano',
        titulo: 'Técnica Americano',
        valor: 'R$ 190,00',
        ratio: '663 / 600',
        imagem: require('./src/procedimentos/Tecnica Americano.png'),
    },
    {
        id: 'brasileiro',
        titulo: 'Técnica Brasileiro',
        valor: 'R$ 150,00',
        ratio: '705 / 593',
        imagem: require('./src/procedimentos/Tecnica Brasileiro.png'),
    },
    {
        id: 'capping',
        titulo: 'Técnica Capping 30+',
        valor: 'R$ 220,00',
        ratio: '367 / 655',
        imagem: require('./src/procedimentos/Tecnica Capping.png'),
    },
    {
        id: 'fox',
        titulo: 'Técnica Fox',
        valor: 'R$ 170,00',
        ratio: '374 / 623',
        imagem: require('./src/procedimentos/Tecnica Fox.png'),
    },
    {
        id: '4d',
        titulo: 'Técnica 4D',
        valor: 'R$ 170,00',
        ratio: '368 / 682',
        imagem: require('./src/procedimentos/Tecnica 4D.png'),
    },
    {
        id: 'russo',
        titulo: 'Técnica Russo',
        valor: 'R$ 220,00',
        ratio: '650 / 672',
        imagem: require('./src/procedimentos/Tecnica Russo.png'),
    },
];

const Photo: React.FC<{ src: string; alt: string; ratio: string }> = ({ src, alt, ratio }) => (
    <div
        className={styles.photo}
        style={{ '--photo-ratio': ratio } as React.CSSProperties}
    >
        <img src={src} alt={alt} />
    </div>
);

const openWhatsApp = (servico: string) => {
    const text = `Olá! Vim pelo site e gostaria de agendar ${servico}.`;
    window.open(
        `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`,
        '_blank',
        'noopener,noreferrer'
    );
};

const Procedimentos_marjorie_lashdesign: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.procedimentos_marjorie_lashdesign}>
                <div className={styles.header}>
                    <Link to="/marjorie_lashdesign" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Procedimentos</h2>
                </div>

                <p className={styles.intro}>
                    Escolha o procedimento e reserve seu horário pelo WhatsApp.
                </p>

                <section className={styles.block}>
                    <Photo
                        src={require('./src/procedimentos/sobrancelha.png')}
                        alt="Sobrancelhas"
                        ratio="580 / 700"
                    />
                    <h3 className={styles.blockTitle}>Sobrancelha</h3>
                    <ul className={styles.priceList}>
                        {SOBRANCELHA.map((item) => (
                            <li key={item.nome}>
                                <span>{item.nome}</span>
                                <strong>{item.valor}</strong>
                            </li>
                        ))}
                    </ul>
                    <button
                        type="button"
                        className={styles.agendarBtn}
                        onClick={() => openWhatsApp('um procedimento de sobrancelha')}
                    >
                        Agendar sobrancelha
                    </button>
                </section>

                <section className={styles.block}>
                    <h3 className={styles.blockTitle}>Técnicas de cílios</h3>
                    <div className={styles.tecnicas}>
                        {TECNICAS.map((item) => (
                            <article key={item.id} className={styles.tecnicaCard}>
                                <Photo src={item.imagem} alt={item.titulo} ratio={item.ratio} />
                                <div className={styles.tecnicaInfo}>
                                    <h4>{item.titulo}</h4>
                                    <span>{item.valor}</span>
                                </div>
                                <button
                                    type="button"
                                    className={styles.agendarBtn}
                                    onClick={() => openWhatsApp(item.titulo)}
                                >
                                    Agendar
                                </button>
                            </article>
                        ))}
                    </div>
                </section>

                <section className={styles.block}>
                    <h3 className={styles.blockTitle}>Outros</h3>
                    <ul className={styles.priceList}>
                        <li>
                            <span>Remoção química</span>
                            <strong>R$ 50,00</strong>
                        </li>
                        <li>
                            <span>Taxa de agendamento</span>
                            <strong>R$ 50,00</strong>
                        </li>
                    </ul>
                    <p className={styles.note}>
                        A taxa de agendamento é cobrada somente via Pix ou transferência. Em caso
                        de desistência da cliente, o valor do agendamento não será reembolsado.
                    </p>
                </section>

                <section className={styles.pagamento}>
                    <h3 className={styles.blockTitle}>Formas de pagamento</h3>
                    <p>Dinheiro, Pix, transferência ou cartão, com taxa do banco.</p>
                </section>

                <section className={styles.ctaSection}>
                    <p className={styles.ctaTitle}>Pronta para agendar?</p>
                    <p className={styles.ctaText}>
                        Fale no WhatsApp e reserve seu horário com a taxa de R$ 50,00.
                    </p>
                    <button
                        type="button"
                        className={styles.agendarBtn}
                        onClick={() => openWhatsApp('um procedimento')}
                    >
                        Quero agendar
                    </button>
                </section>
            </div>
        </div>
    );
};

export default Procedimentos_marjorie_lashdesign;
